import React from 'react';

const SearchResultItem = ({ hit, index, isSelectedHit, onHitClick, updateFootballManagerId, type }) => {
    
  const  confidenceScore = hit.confidenceScore;

  if (type === "team") {
  return (
    <li
      className={`cursor-pointer p-2 rounded ${isSelectedHit ? 'bg-blue-100' : 'hover:bg-gray-100'}`}
      onClick={() => onHitClick(index)}
    >
      <div className="flex justify-between items-center">
        <div>
          <div className="font-semibold">{hit.document.name}</div>
          <div className="text-sm text-gray-600">
            {hit.document.nation && (
              <span className="mr-2">Nation: {hit.document.nation.name}</span>
            )}
            {hit.document.division && (
              <span>Division: {hit.document.division.name}</span>
            )}
          </div>
          <div className="text-sm">
            Confidence Score:{' '}
            <span className={`font-bold ${confidenceScore.score > 80 ? 'text-green-600' : confidenceScore.score > 60 ? 'text-yellow-600' : 'text-red-600'}`}>
              {confidenceScore.score}%
            </span> - {confidenceScore.nameScore * 100} % -  countryScore {confidenceScore.countryScore * 100} % - divisionScore {confidenceScore.divisionScore * 100} %
          </div>
        </div>
        <button
          onClick={(e) => {
            e.stopPropagation();
            updateFootballManagerId(hit.document.fm_id);
          }}
          className="bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded"
        >
          ✓
        </button>
      </div>
    </li>
  );
}else{
  return (
    <li
    key={index}
    className={`cursor-pointer ${
      isSelectedHit ? "bg-blue-200" : ""
    }`}
    onClick={() => onHitClick(index)}
  >
    <div className="flex justify-between items-center">
    <div>
      <img
        src={`https://sortitoutsi.b-cdn.net/uploads/face/${hit.document.fm_id}.png`}
        alt={hit.document.name}
        className="w-24 h-24"
      />
      <p className="text-sm">Name: {hit.document.name}</p>
      <p className="text-sm">
        Division:{" "}
        {hit.document.division ? hit.document.division.name : ""}
      </p>
      <p className="text-sm">
        Nation of club: {hit.document.nation ? hit.document.nation.name : ""}
      </p>
      <p className="text-sm">
        Team: {hit.document.team ? hit.document.team.name : ""}
      </p>
      <p className="text-sm">
        Matching Percentage:{" "}
        <span
          className={`font-bold ${confidenceScore.score > 80 ? 'text-green-600' : confidenceScore.score > 60 ? 'text-yellow-600' : 'text-red-600'}`}>
          {confidenceScore.score}% 
        </span> - scoreName  - {confidenceScore.nameScore * 100} % -  teamNationalityScore {confidenceScore.teamNationalityScore * 100} % - teamScore {confidenceScore.teamScore * 100} %
      </p>
     
    </div>
    <button
          onClick={(e) => {
            e.stopPropagation();
            updateFootballManagerId(hit.document.fm_id);
          }}
          className="bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded"
        >
          ✓
        </button>
    </div>
  </li>
  )
}}



export default SearchResultItem;